module.exports = __webpack_public_path__ + "media/images/paypal-logo-157109b5929d0cc8399b6f3997f63f0b.png";